import React, { Fragment, useContext } from "react";
import AuthContext from "../../context/auth/AuthContext";
import PatronSubscribeList from "./PatronSubscribeList";
import SponsorSubscribe from "./SponsorSubscribe";
import usePageTitle from "../../hooks/usePageTitle";

const SubscribeCard = (props) => {
  const authContext = useContext(AuthContext);
  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Subscription",
  });

  const { user } = authContext;

  return (
    <Fragment>
      {user.sponsor ? (
        <SponsorSubscribe
          resetUseIdleTimer={props.resetUseIdleTimer}
          mainContentRef={props.mainContentRef}
        />
      ) : (
        <PatronSubscribeList
          resetUseIdleTimer={props.resetUseIdleTimer}
          mainContentRef={props.mainContentRef}
        />
      )}
    </Fragment>
  );
};

export default SubscribeCard;
